'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  RowWithStripe: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0.5rem',
    position: function position(_ref) {
      var editable = _ref.editable;
      return editable ? 'static' : 'relative';
    },
    justifyContent: 'center'
  },
  background: {
    position: 'absolute',
    left: 0,
    top: '5rem',
    width: '100%',
    height: '5rem'
  }
};
var Stripe = function Stripe(_ref2) {
  var color = _ref2.color,
    className = _ref2.className;
  return _react2.default.createElement('svg', {
    className: className,
    version: '1.1',
    width: '400',
    height: '40',
    viewBox: '0 0 400 40',
    preserveAspectRatio: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('g', null, _react2.default.createElement('path', {
    className: 'horizontal-stripe',
    d: 'M0 0 L400 20 V40 H0Z',
    stroke: 'none',
    fill: color
  })));
};
var RowWithStripe = function (_Component) {
  _inherits(RowWithStripe, _Component);
  function RowWithStripe() {
    _classCallCheck(this, RowWithStripe);
    return _possibleConstructorReturn(this, (RowWithStripe.__proto__ || Object.getPrototypeOf(RowWithStripe)).apply(this, arguments));
  }
  _createClass(RowWithStripe, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        children = _props.children;
      var accentColor = otherProperties.accentColor;
      return _react2.default.createElement('div', {
        className: classes.RowWithStripe,
        style: cssProperties
      }, _react2.default.createElement(Stripe, {
        color: accentColor,
        className: classes.background
      }), children);
    }
  }]);
  return RowWithStripe;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(RowWithStripe);